import React from "react"
import PropTypes from "prop-types"
import {Link} from "react-router-dom"
import { routes } from "router/routes"
import { Flex, Space } from "antd"
import { Text, Title } from "ui/Typography"
import { SettingOutlined } from "@ant-design/icons"
import styles from "./index.module.css"
import { corners } from "themes/variables"
import { useTranslation } from "react-i18next"

const BreadcrumbItem = ({ children, showDivider = true }) => (
  <Flex gap={corners.S} align="center">
    {showDivider && (
      <Text size="lg" className={styles.clientHeaderTitle}>
        ·
      </Text>
    )}
    <Text size="lg" className={styles.clientHeaderTitle}>
      {children}
    </Text>
  </Flex>
)

BreadcrumbItem.propTypes = {
  children: PropTypes.node,
  showDivider: PropTypes.bool,
}

export const DigitalWaiverAndContractsBreadcrumb = () => {
  const { t } = useTranslation()
  return (
    <Space className="mb-4xl w-full" gap={corners.S} align="center">
      <SettingOutlined />
      <Link to={routes.ProDigitalWaiverAndContracts()} style={{ textDecoration: "none" }}>
        <Title level={5} className={`${styles.digitalWaiverTitle}`}>
          {t("digital_waiver_and_contracts.digital_waiver_and_contracts")}
        </Title>
      </Link>
    </Space>
  )
}
